import { useTranslation } from '../../contexts/TranslationContext'
import Button from '../../components/ui/Button'
import { ui } from '../../styles/ui'

export default function QueueSettingsSection({
  queueKeys, engines, queueEngines, queueProcessing, queueToggleLoading,
  promptLabel, promptValue, onQueueEngineChange, onPromptChange, onToggle,
}) {
  const { t } = useTranslation()
  return queueKeys.map((queue) => (
    <div key={queue.key} className={ui.card}>
      <div className={ui.cardBody}>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-lg font-semibold text-foreground">{queue.label}</h2>
            <p className={ui.subtitle}>{t('Select the primary and fallback engines for', 'Select the primary and fallback engines for')} {queue.label.toLowerCase()}.</p>
          </div>
          <div className="flex items-center gap-2">
            <span className={`${ui.badge} ${queueProcessing[queue.key] ? ui.badgeSuccess : ui.badgeError}`}>
              {queueProcessing[queue.key] ? t('Enabled', 'Enabled') : t('Disabled', 'Disabled')}
            </span>
            <Button type="button" variant={queueProcessing[queue.key] ? 'ghost' : 'primary'}
              onClick={() => onToggle(queue.key)} disabled={queueToggleLoading[queue.key]}>
              {queueToggleLoading[queue.key] ? t('Updating...', 'Updating...') : queueProcessing[queue.key]
                ? t('Disable queue', 'Disable queue') : t('Enable queue', 'Enable queue')}
            </Button>
          </div>
        </div>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          {['primary', 'fallback'].map((field) => (
            <div key={field}>
              <label htmlFor={`queue-${queue.key}-${field}`} className={ui.label}>{field === 'primary' ? t('Primary engine', 'Primary engine') : t('Fallback engine', 'Fallback engine')}</label>
              <select id={`queue-${queue.key}-${field}`} aria-label={`${field === 'primary' ? 'Primary' : 'Fallback'} engine for ${queue.key} queue`}
                value={queueEngines[queue.key][field]} onChange={(event) => onQueueEngineChange(queue.key, field, event.target.value)} className={'mt-1 ' + ui.select}>
                <option value="">{field === 'primary' ? t('Default engine', 'Default engine') : t('Default fallback', 'Default fallback')}</option>
                {engines.map((engine) => <option key={engine.id} value={engine.id}>{engine.name || engine.id}</option>)}
              </select>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <label htmlFor={`queue-prompt-${queue.key}`} className={ui.label}>{promptLabel(queue.key, t)}</label>
          <textarea id={`queue-prompt-${queue.key}`} rows={8} value={promptValue(queue.key)}
            onChange={(event) => onPromptChange(queue.key, event.target.value)}
            disabled={!queueEngines[queue.key].primary}
            placeholder={queueEngines[queue.key].primary ? '' : t('Select a primary engine to edit prompt for this queue', 'Select a primary engine to edit prompt for this queue')}
            className={'mt-1 min-h-[220px] w-full ' + ui.input} />
          {!queueEngines[queue.key].primary && <p className="mt-1 text-xs text-muted-foreground">{t('Prompt editor is disabled until a primary engine is selected for the queue.', 'Prompt editor is disabled until a primary engine is selected for the queue.')}</p>}
        </div>
      </div>
    </div>
  ))
}
